import { Expedition } from './experience/game';
import './styles/expedition.css';

try { new Expedition(); }
catch (error) {
  console.error('Unable to start the expedition', error);
  document.getElementById('app')!.innerHTML = '<div class="startup-error"><h1>The world could not wake up.</h1><p>This game needs a browser with WebGL enabled. Try reloading or enabling hardware acceleration.</p><button onclick="location.reload()">Try again</button></div>';
}
